

















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GDescriptionModal',
  props: {
    texts: { type: Array as PropType<string[]>, required: true },
    onClose: { type: Function as PropType<() => void>, default: null },
  },
});
